var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWillPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 78,
    viewBox: "0 0 88 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07794 11C2.07794 6.58172 5.65966 3 10.0779 3H16.0779C20.4962 3 24.0779 6.58172 24.0779 11V19H2.07794V11Z",
    fill: "#e2d1fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0779 3H65.0779C71.1531 3 76.0779 7.92487 76.0779 14V76H32.0779C27.6597 76 24.0779 72.4183 24.0779 68V8L19.0779 3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0779 68C85.0779 71.866 81.9439 75 78.0779 75L38.0779 75L38.0779 59L85.0779 59L85.0779 68Z",
    fill: "#e2d1fa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0779 2C7.00281 2 2.07794 6.93697 2.07794 13.027V18C2.07794 18.5523 2.52566 19 3.07794 19H23.0779C23.6302 19 24.0779 18.5523 24.0779 18V13.027C24.0779 6.93697 19.1531 2 13.0779 2Z",
    stroke: "#090927",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0779 76L75.0779 76C81.1531 76 86.0779 71.063 86.0779 64.973L86.0779 60C86.0779 59.4477 85.6302 59 85.0779 59L40.0779 59C39.5257 59 39.0779 59.4477 39.0779 60L39.0779 66C39.0779 69.3333 37.6779 76 32.0779 76ZM32.0779 76C27.0779 76 24.0779 72 24.0779 67",
    stroke: "#090927",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0779 59V13.027C76.0779 6.93697 71.1531 2 65.0779 2H13.0779",
    stroke: "#090927",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0779 18.5V67",
    stroke: "#090927",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5779,
    cy: 32.5,
    r: 13,
    fill: "#e2d1fa",
    stroke: "#090927",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.0779,
    y: 26,
    width: 3,
    height: 13,
    rx: 1.5,
    fill: "#090927"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0779,
    y: 34,
    width: 3,
    height: 13,
    rx: 1.5,
    transform: "rotate(-90 44.0779 34)",
    fill: "#090927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWillPlan);
export default __webpack_public_path__ + "static/media/add-will-plan.534ff53b31f1801717d133f97c00df0b.svg";
export { ForwardRef as ReactComponent };